import React from 'react';
import { ReceiveGoodsData } from '../receivingTypes';
import { ReceiveItemRow } from './ReceiveItemRow';
import { ReceivingVariance } from '../../../../services/purchaseOrdersApi';
import styles from './ReceiveGoods.module.css';

interface ReceiveGoodsProps {
  data: ReceiveGoodsData;
  onItemChange: (id: string, field: string, value: string | boolean) => void;
  onConfirm: () => void;
  submitting?: boolean;
  error?: string | null;
  /** Variance rows (short/over count or damage) recorded by the last submitted receipt. */
  variances?: ReceivingVariance[];
}

export const ReceiveGoods: React.FC<ReceiveGoodsProps> = ({
  data,
  onItemChange,
  onConfirm,
  submitting,
  error,
  variances,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>Receive Goods - {data.poReference}</h2>
        <p className={styles.vendor}>Vendor: {data.vendorName}</p>
      </div>

      <div className={styles.itemsList}>
        {data.items.map((item) => (
          <ReceiveItemRow
            key={item.id}
            item={item}
            onItemChange={onItemChange}
          />
        ))}
      </div>

      {error && (
        <div style={{ margin: '8px 0', padding: 10, background: '#FEF2F2', color: '#B91C1C', borderRadius: 6, fontSize: 13 }}>
          {error}
        </div>
      )}

      {variances && variances.length > 0 && (
        <div style={{ margin: '8px 0', padding: 10, background: '#FFFBEB', color: '#92400E', borderRadius: 6, fontSize: 13 }}>
          <strong>Receiving variance recorded — flagged for review:</strong>
          <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
            {variances.map((v) => (
              <li key={v.id}>
                {v.sku_code}: expected {v.quantity_expected}, received {v.quantity_received}
                {v.damaged_quantity > 0 ? `, ${v.damaged_quantity} damaged` : ''}
                {v.variance !== 0 ? ` (variance ${v.variance > 0 ? '+' : ''}${v.variance})` : ''}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className={styles.actionBar}>
        <button className={styles.btnConfirm} onClick={onConfirm} disabled={submitting}>
          {submitting ? 'Submitting…' : 'Submit Receipt'}
        </button>
      </div>
    </div>
  );
};
